import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LogoMark } from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      navigate("/admin");
    } catch (err) {
      setError(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="admin-login-page" className="bg-[#F8FAFC] border-b border-slate-200">
      <div className="mx-auto max-w-md px-4 py-20">
        <form
          onSubmit={onSubmit}
          className="bg-white border border-slate-200 rounded-sm p-8"
          data-testid="admin-login-form"
        >
          <LogoMark className="h-9 w-auto" />
          <h1 className="mt-5 text-xl font-semibold text-slate-900">Admin Login</h1>
          <p className="mt-1 text-sm text-slate-500">Enquiry management for Radiant Machine Tools.</p>

          <label htmlFor="admin-email" className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mt-6 mb-1.5">
            Email
          </label>
          <input
            id="admin-email"
            type="email"
            required
            data-testid="admin-login-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-slate-300 rounded-sm px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
          />
          <label htmlFor="admin-password" className="block text-xs font-semibold uppercase tracking-wider text-slate-600 mt-4 mb-1.5">
            Password
          </label>
          <input
            id="admin-password"
            type="password"
            required
            data-testid="admin-login-password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-slate-300 rounded-sm px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#2563EB]/40 focus:border-[#2563EB]"
          />

          {error && (
            <p data-testid="admin-login-error" className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm px-3 py-2">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="mt-6 w-full bg-[#2563EB] hover:bg-[#1D4ED8] disabled:opacity-60 text-white text-sm font-semibold px-6 py-3 rounded-sm transition-colors duration-150"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default AdminLogin;
